import { getErrorMessage, isAPIError } from "@/core/services";
import type { ToastApi } from "@/ds";
import { deleteRole } from "@/modules/roles";
import type { Role } from "@/modules/roles";
import {
  CONFLICT_STATUS,
  DELETE_ERROR_MESSAGE,
  DELETE_FORBIDDEN_MESSAGE,
  DELETE_SUCCESS_MESSAGE,
} from "../roles.constants";

interface UseRolesExclusaoParams {
  readonly toast: ToastApi;
  /** Sucesso: a tela fecha o pop-up e refaz a consulta. */
  readonly onDeleted: () => void;
  /** O serviço recusou por haver usuários vinculados (RN03 da HU 870). */
  readonly onBlocked: (role: Role) => void;
}

/** Model da exclusão (HU 870). */
export function useRolesExclusao({ toast, onDeleted, onBlocked }: UseRolesExclusaoParams) {
  /** Nunca rejeita: a falha mantém o pop-up aberto e o perfil na listagem. */
  return async (role: Role): Promise<void> => {
    try {
      await deleteRole({ id: role.id });
    } catch (error) {
      // A contagem da listagem pode estar defasada: quem decide é o serviço.
      if (isAPIError(error) && error.status === CONFLICT_STATUS) {
        onBlocked(role);
        return;
      }

      const isForbidden = isAPIError(error) && error.status === 403;
      toast.error(
        isForbidden ? "Acesso não autorizado" : DELETE_ERROR_MESSAGE,
        isForbidden ? DELETE_FORBIDDEN_MESSAGE : getErrorMessage(error),
      );
      return;
    }

    onDeleted();
    toast.success("Sucesso", DELETE_SUCCESS_MESSAGE);
  };
}
